import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة معدل نبضات القلب أثناء التمرين";
const DESCRIPTION =
  "حاسبة معدل ضربات القلب المثالي: حدد نطاق ضربات قلبك المستهدف للتمارين (الدهون الحرق، التحمل القلبي) بناءً على عمرك وشدة التمرين! أداة ضرورية للرياضيين والمدربين لمتابعة الصحة القلبية.";
const KEYWORDS = "معدل نبضات القلب, التمرين, اللياقة البدنية";
const OG_URL = "https://do-calculate.com/calculator/ar/heartbeat-calculator/";
function HeartbeatCalculator() {
  const [age, setAge] = useState("");
  const [intensity, setIntensity] = useState(50);
  const [result, setResult] = useState();
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      if (age && intensity >= 0 && intensity <= 100) {
        const maxHeartRate = 220 - parseInt(age);
        const targetHeartRate = Math.round((maxHeartRate * intensity) / 100);
        const lowerBound = Math.round(maxHeartRate * 0.5);
        const upperBound = Math.round(maxHeartRate * 0.85);
        setResult({
          targetHeartRate,
          lowerBound,
          upperBound,
        });
      } else {
        throw new Error("يرجى إدخال جميع القيم بشكل صحيح.");
      }
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  تقوم هذه الحاسبة بحساب معدل نبضات القلب المثالي أثناء التمرين.
                </p>
                <p>لحساب النتيجة، يرجى إدخال عمرك وشدة التمرين.</p>
                <p>
                  لحساب ضربات القلب المستهدفة، عليك أولاً تحديد أقصى معدل لنبضات
                  قلبك. يمكنك حساب هذا المعدل باستخدام إحدى الطريقتين الشائعتين:
                </p>
                <ul>
                  <li>معدل نبضات القلب القصوى = 220 - عمر الفرد بالسنوات</li>
                  <li>
                    معدل نبضات القلب القصوى = 206.9 - (0.67 × عمر الفرد
                    بالسنوات)
                  </li>
                </ul>
                تعد الطريقة الأولى أسهل مقارنة بالطريقة الثانية، ولكن الطريقة
                الثانية تعد أكثر دقة.
                <div>
                  <br />
                </div>
                <p>
                  النطاق المثالي لضربات القلب أثناء التمرين يعتمد على شدة
                  التمرين. إليك بعض النطاقات المقترحة:
                </p>
                <ul>
                  <li>تمارين خفيفة: 57% - 63%</li>
                  <li>تمارين معتدلة: 64% - 76%</li>
                  <li>تمارين هوائية: 70% - 80%</li>
                  <li>تمارين شديدة: 77% - 95%</li>
                  <li>تمارين قصوى: 96% - 100%</li>
                </ul>
                <p>
                  تم تطوير هذه الحاسبة بالاعتماد على{" "}
                  <a
                    href="https://www.heartonline.org.au/resources/calculators/target-heart-rate-calculator"
                    rel="nofollow"
                  >
                    مؤسسة القلب الوطنية في استراليا
                  </a>
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="rtl">
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="age">
                        ادخل عمرك
                      </label>
                      <input
                        id="age"
                        type="number"
                        value={age}
                        onChange={(e) => setAge(e.target.value)}
                        placeholder="أدخل عمرك"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="intensity">
                        اختر شدة التمرين
                      </label>
                      <select
                        id="intensity"
                        value={intensity}
                        onChange={(e) => setIntensity(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        {[...Array(101).keys()].map((value) => (
                          <option key={value} value={value}>
                            {value}
                          </option>
                        ))}
                      </select>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      خطأ: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>النتيجة:</h4>
                      <p className="text-white">
                        معدل نبضات القلب عند هذا المستوى{" "}
                        {result.targetHeartRate} في الدقيقة
                      </p>
                      <p className="text-white">
                        النطاق المستهدف الموصى به: {result.lowerBound} إلى{" "}
                        {result.upperBound} نبضة في الدقيقة
                      </p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">معلومات إضافية</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      ما هو معدل نبضات القلب المثالي؟
                    </h2>{" "}
                  </u>
                  <p>
                    معدل نبضات القلب المثالي هو المعدل الذي يجب أن يصل إليه قلبك
                    أثناء التمرين لتحقيق أقصى استفادة من النشاط البدني.
                  </p>
                  <div className="p-3 mb-2 bg-info ">
                    مثال: شخص عمره 25 و شدة تمرينه تساوي 50%. يكون معدل نبضات
                    القلب يساوي تقريباً 97 في الدقيقة{" "}
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      كيف يتم حساب معدل نبضات القلب؟
                    </h2>{" "}
                  </u>
                  <p>
                    يتم حساب معدل نبضات القلب المثالي بناءً على عمرك وشدة
                    التمرين. يستخدم الأطباء والمدربين هذه الحسابات لتحديد الشدة
                    المناسبة لك.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    يمكنك حساب هذا المعدل باستخدام إحدى الطريقتين الشائعتين:
                    معدل نبضات القلب القصوى = 220 - عمر الفرد بالسنوات معدل
                    نبضات القلب القصوى = 206.9 - (0.67 × عمر الفرد بالسنوات)
                  </div>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default HeartbeatCalculator;
